import { getRenewalSegmentCount, getRenewalAggrementCount, getRenewalFlagsCount, getCurrentDashboard } from "../../../http/renewalHttp/RenewalHttp";
import { getRenewalTeamDomainCount } from "../../../http/renewalHttp/RenewalMemberHttp";
import Div from "../../../components/Div"
// import RenewalHistory from "../../components/Dashboards/RenewalHistory"
// import RenewalStatus from "../../components/Dashboards/RenewalStatus"
import RenewalTeam from "../../../components/Dashboards/RenewalTeam"
import { useEffect, useState, useCallback } from "react"
import Input from "../../../components/Input"


export default function RenewalDashboard() {

    const [teamDomain, setTeamDomain] = useState(false);

    const [segmentCount, setSegmentCount] = useState(false);

    const [aggrementCount, setAggrementCount] = useState(false);

    const [flagsCount, setFlagsCount] = useState(false);

    const [currentDashboard, setCurrentDashboard] = useState(false);

    const getCurrentYearMonth = () => {
        const date = new Date();
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
      };

    const [month, setMonth] = useState(getCurrentYearMonth)

    const getTeamData = useCallback( async () => {
        try {
            const response = await getRenewalTeamDomainCount(month)
            console.log(response)

            const columns = <> <th style={{
                position: "sticky",
                top: 0,
                backgroundColor: "#f1f1f1",
                zIndex: 100,
            }}>Team Member Email</th>
                <th style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f1f1f1",
                    zIndex: 100,
                }}>Domain Count</th>
            </>

            setTeamDomain({
                data: response.domains,
                columns: columns,
                month : month
            });

        } catch (error) {
            console.log(error)
        }
    },[month])

    const getSegmentCountData = useCallback( async () => {
        try {
            const response = await getRenewalSegmentCount(month)
           
            const columns = <> <th style={{
                position: "sticky",
                top: 0,
                backgroundColor: "#f1f1f1",
                zIndex: 100,
            }}>Segments</th>
                <th style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f1f1f1",
                    zIndex: 100,
                }}>Segment Count</th>
            </>

            setSegmentCount({
                data: response.segments,
                columns: columns
            });

        } catch (error) {
            console.log(error)
        }
    },[month])

    const getAggrementCountData = useCallback( async () => {
        try {
            const response = await getRenewalAggrementCount(month)
            console.log(response)
            const columns = <> <th style={{
                position: "sticky",
                top: 0,
                backgroundColor: "#f1f1f1",
                zIndex: 100,
            }}>Aggrement Status</th>
                <th style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f1f1f1",
                    zIndex: 100,
                }}>Aggment Count</th>
            </>

            setAggrementCount({
                data: response.aggrements,
                columns: columns
            });

        } catch (error) {
            console.log(error)
        }
    },[month])

    const getFlagStatusCoutData = useCallback( async () => {
        try {
            const response = await getRenewalFlagsCount(month)
            console.log(response)

            const columns = <> <th style={{
                position: "sticky",
                top: 0,
                backgroundColor: "#f1f1f1",
                zIndex: 100,
            }}>Flag Status</th>
                <th style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f1f1f1",
                    zIndex: 100,
                }}>Flag Count</th>
            </>

            setFlagsCount({
                data: response.flags,
                columns: columns
            });

        } catch (error) {
            console.log(error)
        }
    }, [month])

    function handleMonthChange(event) {
        const filterMonth = event.target.value
        setMonth(filterMonth)
    }

    const getCurrentDashboardData = useCallback( async () => {
        try {
            const response = await getCurrentDashboard(month)
            console.log(response)

            const columns = <> <th style={{
                position: "sticky",
                top: 0,
                backgroundColor: "#f1f1f1",
                zIndex: 100,
            }}>Monthly</th>
                <th style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f1f1f1",
                    zIndex: 100,
                }}>Count</th>
            </>

            setCurrentDashboard({
                data: response.flags,
                columns: columns
            });

        } catch (error) {
            console.log(error)
        }
    },[month])

    useEffect(() => {

        getTeamData()
        getAggrementCountData()
        getSegmentCountData()
        getFlagStatusCoutData()
        getCurrentDashboardData()

    }, [getTeamData, getAggrementCountData, getSegmentCountData, getFlagStatusCoutData, getCurrentDashboardData]);

    const tableStyle = {
        width: "50%", // Ensure each chart takes up 48% of the container width
        height: "500px",
        border: "1px solid #ddd", // Add border to the chart
        borderRadius: "10px", // Rounded corners for the chart
        padding: "15px", // Padding inside the chart container
        backgroundColor: "#fff",
        margin: '30px', // Background color for better visibility
    };

    
    return <>
            <Div className='row justify-content-center'>
                {/* <Div style={{ margin: '50px' }}>
                <RenewalHistory />
            </Div>
            <Div style={{ margin: '50px' }}>
                <RenewalStatus />
            </Div> */}

            <Div>
                <Input type='month' name='month' id='month' style={{ marginLeft: '50px' }} value={month}
                                        onChange={handleMonthChange}
                                    />
            </Div>

       
                <Div className='col-3' style={tableStyle}>
                    <RenewalTeam title='Renewal Team Domain' data={teamDomain.data}
                        columns={teamDomain.columns} selectedMonth={teamDomain.month} tag='team' />
                </Div>

                <Div className='col-3' style={tableStyle}>
                    <RenewalTeam title='Segment Dashboard' data={segmentCount.data}
                        columns={segmentCount.columns} tag='segments' />
                </Div>

                <Div className='col-3' style={tableStyle}>
                    <RenewalTeam title='Aggrement Status' data={aggrementCount.data}
                        columns={aggrementCount.columns} tag='aggrements' />
                </Div>
            </Div>

            <Div className='row justify-content-center'>


                <Div className='col-3' style={tableStyle}>
                    <RenewalTeam title='Flag Status' data={flagsCount.data}
                        columns={flagsCount.columns} tag='flags' />
                </Div>

                <Div className='col-3' style={tableStyle}>
                    <RenewalTeam title='Monthly Dashboard' data={currentDashboard.data}
                        columns={currentDashboard.columns} tag='current' />
                </Div>

            </Div>

            <Div className='row justify-content-center'>

            </Div>
    </>
}